import { Group, Select, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import Button from "../../components/Button";
import InputField from "../../components/inputField";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { addAndEditData } from "../generalPostAndEditData";

export const AddLookUp = ({
  opened,
  setOpened,
  lookupsTypes,
  setUpdate,

  editData,
  setEditData,
  editModalState,
  setEditModalState,
  setLoading,
}) => {
  console.log("lookupsTypes", lookupsTypes);
  const lookUpLists = lookupsTypes?.map((lookupType) => ({
    label: lookupType,
    value: lookupType,
  }));
  console.log("hiii", lookUpLists);
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      lookupType: "",
      lookupName: "",
    },

    validate: {
      lookupType: (value) =>
        value ? null : "Please select a valid industry type",

      lookupName: (value) =>
        value?.trim()?.length > 1 && /^[a-zA-Z\s]*$/.test(value.trim())
          ? null
          : "Alphabetic Name with 2 or more characters",
    },
  });

  // const onSubmit = (values) => {
  //   addLookUp(values, setOpened);
  // };
  const onSubmit = (values) => {
    let url = "";
    if (!editModalState) {
      url = "lookup/addLookup";
    } else {
      values.lookupId = editData._id;
      url = "lookup/editLookup";
      setEditData({});
      setEditModalState(false);
    }
    form.reset();
    setLoading(true);
    addAndEditData(values, setOpened, setUpdate, url);
  };

  useEffect(() => {
    if (editModalState) {
      console.log("editModalState", editModalState);
      form.setValues({
        lookupType: editData.lookupType,
        lookupName: editData.lookupName,
      });
    }
  }, [opened]);
  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb={0} weight={500}>
        Look Up Type
      </Text>
      <Select
        styles={{
          input: {
            padding: "1.2rem",
          },
        }}
        required
        withAsterisk={false}
        placeholder="Select Look Up Type"
        data={lookUpLists}
        // searchable
        nothingFound="No Lookup Type found"
        {...form.getInputProps("lookupType")}
      />
      <Text mt="lg" mb={0} weight={500}>
        Look Up Name
      </Text>
      <InputField
        width="100%"
        placeholder="Enter Look Up Name"
        form={form}
        validateName="lookupName"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            form.reset();
          }}
        />
        <Button
          title={editModalState ? "Edit" : "Add"}
          primary={true}
          fontWeight="700"
          type="submit"
        />
      </Group>
    </form>
  );

  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      InternalComponent={InternalContent}
      title={editModalState ? "Edit Look Up" : "Add Look Up"}
      form={form}
    />
  );
};
